import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=0ded042d&scoped=true"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=0ded042d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded042d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ded042d')) {
      api.createRecord('0ded042d', component.options)
    } else {
      api.reload('0ded042d', component.options)
    }
    module.hot.accept("./Impressum.vue?vue&type=template&id=0ded042d&scoped=true", function () {
      api.rerender('0ded042d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Impressum.vue"
export default component.exports